var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6094 14.25L23.5 16.25L25.5 18.25M24.5781 16.25H29.25C29.8023 16.25 30.25 16.6977 30.25 17.25V26.75C30.25 27.3023 29.8023 27.75 29.25 27.75H23.75M19.25 27.5C19.25 29.0188 18.0188 30.25 16.5 30.25C14.9812 30.25 13.75 29.0188 13.75 27.5C13.75 25.9812 14.9812 24.75 16.5 24.75C18.0188 24.75 19.25 25.9812 19.25 27.5ZM19.25 16.5C19.25 18.0188 18.0188 19.25 16.5 19.25C14.9812 19.25 13.75 18.0188 13.75 16.5C13.75 14.9812 14.9812 13.75 16.5 13.75C18.0188 13.75 19.25 14.9812 19.25 16.5Z",
    stroke: "#151918",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowIcon);
export default __webpack_public_path__ + "static/media/workflow-icon.f74e380ae5ac0f3beadf0b5030fc9f2b.svg";
export { ForwardRef as ReactComponent };